export default function faq() {
	// Faq
	let faqDrop = document.querySelectorAll('.Dropdown');

	function showText(event) {
		if (event.target.className == "Dropdown Dropdown-main Dropdown--active") {
			event.target.classList.remove('Dropdown--active');
		} else {
			if (document.querySelector('.Dropdown--active')) {
				let activeItem = document.querySelector('.Dropdown--active');
				activeItem.classList.remove('Dropdown--active');
				event.target.classList.add('Dropdown--active');
			} else {
				event.target.classList.add('Dropdown--active');
			}
		}
	};

	faqDrop.forEach(function (item) {
		item.addEventListener('click', showText)
	});
}
